import { changeIntegrationPreventTranslations } from 'actions/integrationSettings';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getIntegrationSettingsForm } from 'selectors/integrationSettings';
import { useSelector } from 'store';

const TranslationsPrevent: React.FC = () => {
  const dispatch = useDispatch();

  const { additional_language_offerings: translations } = useSelector(getIntegrationSettingsForm);

  const handleTranslationsChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    dispatch(changeIntegrationPreventTranslations(e.target.value === 'true'));
  };

  return (
    <div className="flex flex-col gap-2">
      <div>
        <span>Are additional language offerings (besides English) needed for Prevent?</span>
        <span className="litlingo-red-color">*</span>
      </div>

      <div>
        <div className="flex flex-col gap-2">
          <label
            htmlFor="prevent-translations-yes"
            className="flex justify-start items-center w-22"
          >
            <input
              type="radio"
              id="prevent-translations-yes"
              name="prevent-translations"
              value="true"
              onChange={handleTranslationsChange}
              checked={translations === true}
              className="input-radio"
            />
            <span className="text ml-1">Yes</span>
          </label>
          <label htmlFor="prevent-translations-no" className="flex justify-start items-center w-22">
            <input
              type="radio"
              id="prevent-translations-no"
              name="prevent-translations"
              value="false"
              onChange={handleTranslationsChange}
              checked={translations === false}
              className="input-radio"
            />
            <span className="text ml-1">No</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default TranslationsPrevent;
